import { render } from "./FornitureGas.vue?vue&type=template&id=e5c7a404"
import script from "./FornitureGas.vue?vue&type=script&lang=js"
export * from "./FornitureGas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__